"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var classNames = require("classnames");
var react_tracking_1 = require("react-tracking");
var tracker_1 = require("../tracker");
var condition_display_1 = require("./condition_display");
var price_display_1 = require("./price_display");
var image_carousel_1 = require("./image_carousel");
var ribbon_view_1 = require("./ribbon_view");
var rql_1 = require("../rql");
var watch_badge_1 = require("./watch_badge");
var core_link_1 = require("./core_link");
var url_helpers_1 = require("../url_helpers");
var user_context_provider_1 = require("./user_context_provider");
var DIGITAL_LISTING_UUID = 'e71b6e43-7217-4746-b4e3-64bf708a2664';
var DISPLAY_STYLE = 'squareCard';
var ListingCard = /** @class */ (function (_super) {
    tslib_1.__extends(ListingCard, _super);
    function ListingCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingCard.prototype.auction = function () {
        return this.props.listing.listingType === rql_1.core_apimessages_Listing_ListingType.AUCTION;
    };
    ListingCard.prototype.freeExpeditedShipping = function () {
        var _a;
        return !!((_a = this.props.listing.shipping) === null || _a === void 0 ? void 0 : _a.freeExpeditedShipping);
    };
    ListingCard.prototype.freeShipping = function () {
        var _a, _b, _c;
        return !!(((_c = (_b = (_a = this.props.listing.shipping) === null || _a === void 0 ? void 0 : _a.shippingPrices) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.rate.amountCents) === 0);
    };
    ListingCard.prototype.isDigitalListing = function () {
        if (!this.props.listing.categoryUuids) {
            return false;
        }
        return this.props.listing.categoryUuids.includes(DIGITAL_LISTING_UUID);
    };
    ListingCard.prototype.localPickupOnly = function () {
        var _a;
        return !!((_a = this.props.listing.shipping) === null || _a === void 0 ? void 0 : _a.localPickupOnly);
    };
    ListingCard.prototype.listingUrl = function () {
        if (this.props.soldListing) {
            return (url_helpers_1.ITEM_WITH_SLUG_ROUTE.expand({
                slug: this.props.listing.slug,
                id: this.props.listing.id,
                show_sold: true,
            }));
        }
        return (url_helpers_1.ITEM_WITH_SLUG_ROUTE.expand({
            slug: this.props.listing.slug,
            id: this.props.listing.id,
        }));
    };
    ListingCard.prototype.renderConditionDisplay = function () {
        if (this.isDigitalListing())
            return;
        return (React.createElement("div", { className: "grid-card__condition" },
            React.createElement(condition_display_1.default, { slug: this.props.listing.condition.conditionSlug, displayName: this.props.listing.condition.displayName })));
    };
    ListingCard.prototype.hasDiscount = function () {
        return !!this.props.listing.pricing.originalPrice;
    };
    ListingCard.prototype.ribbonText = function () {
        return this.props.listing.pricing.ribbon ?
            this.props.listing.pricing.ribbon.display :
            null;
    };
    ListingCard.prototype.renderOriginalPrice = function () {
        if (!this.hasDiscount()) {
            return null;
        }
        return (React.createElement("div", { className: "grid-card__original-price" }, this.props.listing.pricing.originalPrice.display));
    };
    ListingCard.prototype.renderPrice = function () {
        return (React.createElement(price_display_1.default, { amountCents: this.props.listing.pricing.buyerPrice.amountCents, currency: this.props.listing.pricing.buyerPrice.currency, display: this.props.listing.pricing.buyerPrice.display, auction: this.auction() }));
    };
    ListingCard.prototype.renderCallout = function () {
        if (this.isDigitalListing()) {
            return;
        }
        if (this.freeExpeditedShipping()) {
            return (React.createElement("div", { className: "grid-card__free-2-day" }, I18n.t('cms.freeExpeditedShipping')));
        }
        if (this.freeShipping()) {
            return (React.createElement("div", { className: "grid-card__free-shipping" }, I18n.t('commons.freeShipping')));
        }
        if (this.localPickupOnly()) {
            return (React.createElement("div", { className: "grid-card__local-pickup" }, I18n.t('commons.localPickupOnly')));
        }
        return false;
    };
    ListingCard.prototype.renderPlaceholderCard = function () {
        return (React.createElement("div", { className: "grid-card grid-card--placeholder" },
            React.createElement("div", { className: "grid-card__inner" },
                React.createElement("div", { className: "grid-card__main" },
                    React.createElement("div", { className: "grid-card__image" }),
                    React.createElement("div", { className: "grid-card__main__text" },
                        React.createElement("div", { className: "grid-card__title" }))),
                React.createElement("div", { className: "grid-card__footer" },
                    React.createElement("div", { className: "grid-card__footer__pricing" },
                        React.createElement("div", { className: "grid-card__price" }))))));
    };
    ListingCard.prototype.renderMetadata = function () {
        if (this.props.displayMetadataAsOffer) {
            return (React.createElement("div", { itemProp: "offers", itemScope: true, itemType: "http://schema.org/Offer" },
                React.createElement("meta", { itemProp: "priceCurrency", content: this.props.listing.pricing.buyerPrice.currency }),
                React.createElement("meta", { itemProp: "price", content: "" + this.props.listing.pricing.buyerPrice.amountCents / 100 }),
                React.createElement("meta", { itemProp: "availability", content: "http://schema.org/InStock" }),
                React.createElement("meta", { itemProp: "url", content: "http://reverb.com/" + this.listingUrl() }),
                React.createElement("meta", { itemProp: "gtin14", content: this.props.listing.upc })));
        }
    };
    ListingCard.prototype.render = function () {
        if (!this.props.listing) {
            return this.renderPlaceholderCard();
        }
        var classes = classNames('grid-card', { 'grid-card--software': this.isDigitalListing() }, { 'grid-card--discounted': this.hasDiscount() });
        var images = this.props.listing.images.map(function (i) { return (i.source); });
        return (React.createElement("div", { className: classes },
            React.createElement(core_link_1.default, { className: "grid-card__inner", to: this.listingUrl(), entityId: this.props.listing.id, position: this.props.position },
                this.renderMetadata(),
                React.createElement("div", { className: "grid-card__main" },
                    React.createElement("div", { className: "grid-card__image" },
                        React.createElement(image_carousel_1.default, { images: images, imgAlt: this.props.listing.title }),
                        React.createElement(ribbon_view_1.default, { auction: this.auction(), listingStateDescription: this.props.listing.stateDescription, listingStateSlug: this.props.listing.state, discountDisplay: this.ribbonText() })),
                    React.createElement("div", { className: "grid-card__main__text" },
                        React.createElement("h4", { className: "grid-card__title" }, this.props.listing.title))),
                React.createElement("div", { className: "grid-card__footer" },
                    this.renderCallout(),
                    this.renderOriginalPrice(),
                    React.createElement("div", { className: "grid-card__footer__pricing" },
                        React.createElement("div", { className: "grid-card__price" }, this.renderPrice()),
                        this.renderConditionDisplay()),
                    this.props.footerContent)),
            React.createElement("div", { className: "grid-card__watch" },
                React.createElement(watch_badge_1.default, { listing: this.props.listing }))));
    };
    ListingCard = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                mParticleInteraction: function (data) { return tracker_1.buildListingClickEvent(data, props.listing, { displayStyle: DISPLAY_STYLE }); },
            };
        })
    ], ListingCard);
    return ListingCard;
}(React.Component));
exports.ListingCard = ListingCard;
exports.default = user_context_provider_1.withUserContext(ListingCard);
//# sourceMappingURL=listing_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/listing_card.js
// module id = tUc7
// module chunks = 0 1 2 3 4 6 8 11 12 13 20